<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> Clients </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <!--<button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>-->
      </div>
    </div>
  </div>

  <div class="card-body">
    <!--<div class="row">
      <div class="col">

        <div *ngIf="mode==formModes.Find">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <input [ngModel]="model.Name" maxlength="50" class="form-control form-control-sm" #name="ngModel" type="text" id="Name" name="Name" />
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingID" class="col-sm-3 col-form-label">Billing ID</label>
                <div class="col-sm-9">
                  <input [ngModel]="model.BillingID" maxlength="50" #billingID="ngModel" type="text" class="form-control form-control-sm" id="BillingID" name="BillingID" />
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingContactID" class="col-sm-3 col-form-label">Billing Contact ID</label>
                <div class="col-sm-9">
                  <input [ngModel]="model.BillingContactID" maxlength="50" type="text" class="form-control form-control-sm" id="BillingContactID" name="BillingContactID" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="BillingDay" class="col-sm-3 col-form-label">
                  Billing Day
                </label>
                <div class="col-sm-9">
                  <p-calendar [ngModel]="model.BillingDay" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" id="BillingDay" name="BillingDay"></p-calendar>
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingFrequency" class="col-sm-3 col-form-label">
                  Billing Frequency
                </label>
                <div class="col-sm-9">
                  <p-dropdown [options]="frequency" [ngModel]="model.BillingFrequency" id="BillingFrequency" [autoWidth]="true" placeholder="Select frequency" [showClear]="true"></p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="LastBilled" class="col-sm-3 col-form-label">
                  Last Billed
                </label>
                <div class="col-sm-9">
                  <p-calendar [ngModel]="model.LastBilled" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" id="LastBilled" name="LastBilled"></p-calendar>
                </div>
              </div>
              <div class="form-group row">
                <label for="CarrierId" class="col-sm-3 col-form-label">
                  Carrier
                </label>
                <div class="col-sm-9">
                  <p-dropdown [options]="carriers" [(ngModel)]="model.CarrierId" [filter]="true" filterBy="label" id="CarrierId" name="CarrierId" [autoWidth]="true" placeholder="Select carrier" [showClear]="true"></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" class="btn btn-sm btn-outline-secondary mx-1" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="mode==formModes.New || mode==formModes.Edit">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group row">
                  <label for="Name" class="col-sm-3 col-form-label">Name</label>
                  <div class="col-sm-9">
                    <input [(ngModel)]="model.Name" required maxlength="50" class="form-control form-control-sm" #name="ngModel" type="text" id="Name" name="Name">
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger small">
                      <div *ngIf="name.errors.required">
                        Name is required.
                      </div>
                      <div *ngIf="name.errors.maxlength">
                        Name must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="BillingID" class="col-sm-3 col-form-label">Billing ID</label>
                  <div class="col-sm-9">
                    <input [(ngModel)]="model.BillingID" required maxlength="50" #billingID="ngModel" type="text" class="form-control form-control-sm" id="BillingID" name="BillingID">
                    <div *ngIf="billingID.invalid && (billingID.dirty || billingID.touched)" class="text-danger small">
                      <div *ngIf="billingID.errors.required">
                        BillingID is required.
                      </div>
                      <div *ngIf="billingID.errors.maxlength">
                        Egine must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="BillingContactID" class="col-sm-3 col-form-label">Billing Contact ID</label>
                  <div class="col-sm-9">
                    <input [(ngModel)]="model.BillingContactID" required maxlength="50" #billingContactID="ngModel" type="text" class="form-control form-control-sm" id="BillingContactID" name="BillingContactID">
                    <div *ngIf="billingContactID.invalid && (billingContactID.dirty || billingContactID.touched)" class="text-danger small">
                      <div *ngIf="billingContactID.errors.required">
                        BillingContactID is required.
                      </div>
                      <div *ngIf="billingContactID.errors.maxlength">
                        BillingContactID must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group row">
                  <label for="BillingDay" class="col-sm-3 col-form-label">
                    Billing Day
                  </label>
                  <div class="col-sm-9">
                    <p-calendar required [(ngModel)]="model.BillingDay" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" #billingDay="ngModel" id="BillingDay" name="BillingDay"></p-calendar>
                    <div *ngIf="billingDay.invalid && (billingDay.dirty || billingDay.touched)" class="text-danger small">
                      <div *ngIf="billingDay.errors.required">
                        BillingDay is required.
                      </div>
                      <div *ngIf="billingDay.errors.maxlength">
                        BillingDay must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="BillingFrequency" class="col-sm-3 col-form-label">
                    Billing Frequency
                  </label>
                  <div class="col-sm-9">
                    <p-dropdown [options]="frequency" [(ngModel)]="model.BillingFrequency" required #billingFrequency="ngModel" id="BillingFrequency" name="BillingFrequency" [autoWidth]="true" placeholder="Select frequency" [showClear]="true"></p-dropdown>
                    <div *ngIf="billingFrequency.invalid && (billingFrequency.dirty || billingFrequency.touched)" class="text-danger small">
                      <div *ngIf="billingFrequency.errors.required">
                        BillingFrequency is required.
                      </div>
                      <div *ngIf="billingFrequency.errors.maxlength">
                        BillingFrequency must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="LastBilled" class="col-sm-3 col-form-label">
                    Last Billed
                  </label>
                  <div class="col-sm-9">
                    <p-calendar required [(ngModel)]="model.LastBilled" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" #lastBilled="ngModel" id="LastBilled" name="LastBilled"></p-calendar>
                    <div *ngIf="lastBilled.invalid && (lastBilled.dirty || lastBilled.touched)" class="text-danger small">
                      <div *ngIf="lastBilled.errors.required">
                        LastBilled is required.
                      </div>
                      <div *ngIf="lastBilled.errors.maxlength">
                        LastBilled must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="CarrierId" class="col-sm-3 col-form-label">
                    Carrier
                  </label>
                  <div class="col-sm-9">
                    <p-dropdown required [options]="carriers" [(ngModel)]="model.CarrierId" [filter]="true" filterBy="label" #carrierId="ngModel" id="CarrierId" name="CarrierId" [autoWidth]="true" placeholder="Select carrier" [showClear]="true"></p-dropdown>
                    <div *ngIf="carrierId.invalid && (carrierId.dirty || carrierId.touched)" class="text-danger small">
                      <div *ngIf="carrierId.errors.required">
                        CarrierId is required.
                      </div>
                      <div *ngIf="carrierId.errors.maxlength">
                        CarrierId must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="text-center m-3">
                  <button type="button" class="btn btn-sm btn-outline-secondary mx-1" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.New" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.Edit" class="btn btn-sm btn-primary mx-1"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
                </div>
                <br />
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="mode==formModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <input [ngModel]="model.Name" class="form-control form-control-sm" type="text" id="Name" name="Name" [readonly]="true" />
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingID" class="col-sm-3 col-form-label">Billing ID</label>
                <div class="col-sm-9">
                  <input [ngModel]="model.BillingID" type="text" class="form-control form-control-sm" id="BillingID" name="BillingID" [readonly]="true" />
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingContactID" class="col-sm-3 col-form-label">Billing Contact ID</label>
                <div class="col-sm-9">
                  <input [ngModel]="model.BillingContactID" type="text" class="form-control form-control-sm" id="BillingContactID" name="BillingContactID" [readonly]="true" />
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="BillingDay" class="col-sm-3 col-form-label">
                  Billing Day
                </label>
                <div class="col-sm-9">
                  <p-calendar [ngModel]="model.BillingDay" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" id="BillingDay" name="BillingDay" [disabled]="true"></p-calendar>
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingFrequency" class="col-sm-3 col-form-label">
                  Billing Frequency
                </label>
                <div class="col-sm-9">
                  <p-dropdown [options]="frequency" [ngModel]="model.BillingFrequency" id="BillingFrequency" name="BillingFrequency" [readonly]="true" [autoWidth]="true" placeholder="Select frequency" [showClear]="true"></p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="LastBilled" class="col-sm-3 col-form-label">
                  Last Billed
                </label>
                <div class="col-sm-9">
                  <p-calendar [ngModel]="model.LastBilled" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" id="LastBilled" name="LastBilled" [disabled]="true"></p-calendar>
                </div>
              </div>
              <div class="form-group row">
                <label for="CarrierId" class="col-sm-3 col-form-label">
                  Carrier
                </label>
                <div class="col-sm-9">
                  <p-dropdown [options]="carriers" [(ngModel)]="model.CarrierId" [filter]="true" filterBy="label" id="CarrierId" name="CarrierId" [readonly]="true" [autoWidth]="true" placeholder="Select carrier" [showClear]="true"></p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="resetForm()" class="btn btn-sm btn-outline-secondary mx-1"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>-->

    <div class="row">
      <div class="col">


<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>


    <!-- <ng-container matColumnDef="Id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
      <td mat-cell *matCellDef="let row">{{ row.id }}  </td>
    </ng-container> -->

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
      <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
    </ng-container>

    <ng-container matColumnDef="BillingID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingID </th>
      <td mat-cell *matCellDef="let row"> {{ row.billingID }} </td>
    </ng-container>

    <ng-container matColumnDef="BillingContactID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingContactID </th>
      <td mat-cell *matCellDef="let row">{{ row.billingContactID }}  </td>
    </ng-container>
    <ng-container matColumnDef="BillingDay">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingDay </th>
      <td mat-cell *matCellDef="let row"> {{ row.billingDay | date:'shortDate'}} </td>
    </ng-container>
    <ng-container matColumnDef="BillingFrequency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingFrequency </th>
      <td mat-cell *matCellDef="let row"> {{ frequency | getLabelOf : row.billingFrequency }} </td>
    </ng-container>
    <ng-container matColumnDef="LastBilled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> LastBilled </th>
      <td mat-cell *matCellDef="let row">   {{ row.lastBilled | date:'shortDate' }}         </td>
    </ng-container>
    <!-- <ng-container matColumnDef="CarrierId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> CarrierId </th>
      <td mat-cell *matCellDef="let row"> {{ carriers | getLabelOf : row.carrierId }}   </td>
    </ng-container> -->
   <ng-container matColumnDef="...">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
      <td mat-cell *matCellDef="let row">
         <!-- <div class="btn-group btn-group-sm">
          <a href="{{CarrierInvoiceFileControllerUrl}}/{{e.Id}}?action=download" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
          <button (click)="showDel(e)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
        </div> -->
       </td>
    </ng-container>
    <tr class="mat-row" >
      <td class="mat-cell" colspan="4">There are {{this.tabledata?.length}} record</td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <!-- <ng-template pTemplate="summary">
      There are {{formListData?.length}} Clients
    </ng-template> -->

  </table>
  <table >
    <tr >
      <td style="text-align: center;
      position: relative;
      top: 40px ;" >
       There are {{this.tabledata?.length}} records
      </td>
    </tr>
  </table>
  <!--<tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="4">There is no record</td>
  </tr>-->
  <!-- <div>There are {{this.tabledata.length}} record</div> -->
  <mat-paginator #paginator [length]="this.tabledata?.length" [pageSizeOptions]="[5,10,50, 100]" aria-label="Select page of users"></mat-paginator>
</div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <!--<p-paginator [rows]="10" [totalRecords]="120" [rowsPerPageOptions]="[10,20,30]"></p-paginator>-->
  </div>
</div>


                    <!--<button (click)="showEdit(e)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                  <button (click)="showDel(e)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>-->
